export default {
  title: 'Notifiche push',
  description: 'Invia notifiche push mirate ai tuoi clienti',
  buttons: {
    new_campaign: 'Nuova campagna',
  },
  error_messages: {
    no_mobile_app: {
      title: 'App mobile non ancora attiva',
      description: "Attendi che l'app mobile sia attiva prima di inviare notifiche push",
    },
  },
};
